import { BASE_URL, BASE_URL_DEV } from "../_constants/urlConstants";
const { buildErrResponse } = require("../_utils/utils");
const { default: Axios } = require("axios");

export const DistributionService = {
  createDistribution,
  createBulkDistribution,
  getAllDistributions,
  getDistributionByProductId,
  getAllDistributionsbyStatus,
  getAllDistributionsWithParams,
  getFirstDistributions,
  updateStatusAndInDistributionProduct,
};

function createDistribution(body) {
  return new Promise((resolve, reject) => {
    Axios.post(`${BASE_URL_DEV}/distribution`, body)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function createBulkDistribution(distributionArray) {
  return new Promise((resolve, reject) => {
    Axios.post(`${BASE_URL_DEV}/distribution/bulk`, distributionArray)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAllDistributions() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/distribution`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getDistributionByProductId(productId) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/distribution/by-product-id?id=${productId}`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getFirstDistributions() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/distribution/first-entries`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAllDistributionsbyStatus(status) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/distribution/by-status?status=${status}`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAllDistributionsWithParams(body) {
  const {
    userId,
    statusDistributionId,
    siteDestinationId,
    // distributionIds,
    productTypeId,
    startDate,
    endDate,
  } = body;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/distribution/by-id`, {
      params: {
        userId,
        statusDistributionId,
        siteDestinationId,
        // distributionIds,
        productTypeId,
        startDate,
        endDate,
      },
    })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function updateStatusAndInDistributionProduct(body) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/distribution`, body)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}
